import type { MessageDescriptor } from 'react-intl';

export function getMessageDescriptorByTranslationKey(
  translationKey: string,
  messages: Record<string, MessageDescriptor>,
) {
  try {
    const messageDescriptor = messages[translationKey];
    if (messageDescriptor === undefined) {
      throw new Error('not a valid translation key');
    }
    return messageDescriptor;
  } catch (error) {
    return null;
  }
}
